import {createAsyncThunk} from "@reduxjs/toolkit";
import axios, {AxiosError} from "axios";
import {USER_LOCALSTORAGE_KEY} from "shared/const/localstorage";
import {getTestIdResponse} from "features/model/types/test/getTestIdShema";
import {getModalTests} from "features/model/slice/test/get-test/getTestSlice";
import {setBackData} from "features/model/slice/create-test/create-test-form/createTestForm";
import {setNotFoundError} from "features/model/slice/error/errorSlice";


export const fetchTest = createAsyncThunk(
    'test/getTest',
    async (testId: string | undefined, thunkAPI) => {
        if (!testId) {
            return thunkAPI.rejectWithValue('Не удалось определить тест.');
        }

        try {
            const authToken = localStorage.getItem(USER_LOCALSTORAGE_KEY);
            if (!authToken) {
                return thunkAPI.rejectWithValue('No token found in localStorage.');
            }
            const {token} = JSON.parse(authToken);

            const response = await axios.get<getTestIdResponse>(`/api/tests/${testId}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (response.data.success) {
                thunkAPI.dispatch(getModalTests(response.data.data.model));
                thunkAPI.dispatch(setBackData(response.data.data.model));
                return response.data;
            }

            return thunkAPI.rejectWithValue('Ошибка загрузки теста.');
        } catch (error) {
            const status = (error as AxiosError)?.response?.status;
            if (status) {
                thunkAPI.dispatch(setNotFoundError(status));
            }
            return thunkAPI.rejectWithValue('Ошибка загрузки теста.');
        }
    }
);
